import { isPrivilegedUser } from '../auth/role.utils';
import { tenantIdFromUrl } from '../tenant/tenant-url';
import { User } from '../../shared/models/user.interface';

/**
 * Account lives under the shell the user is currently in:
 * - `/admin/...` → `/admin/account`
 * - `/tenant/:tenantId/...` → `/tenant/:tenantId/account`
 * Fallbacks when there is no shell context (bookmarks, guards).
 */
export function accountCommandsFromContext(
  currentUrl: string,
  user: User | null | undefined,
): string[] {
  if (currentUrl.startsWith('/admin')) {
    return ['/admin', 'account'];
  }

  const tenantId = tenantIdFromUrl(currentUrl);
  if (tenantId) {
    return ['/tenant', tenantId, 'account'];
  }

  return accountCommandsForUser(user);
}

/** Where account should live when we only know the user (no current shell URL). */
export function accountCommandsForUser(user: User | null | undefined): string[] {
  if (isPrivilegedUser(user)) {
    return ['/admin', 'account'];
  }
  const tenant = user?.tenant;
  if (tenant?.id && tenant.is_active !== false) {
    return ['/tenant', tenant.id, 'account'];
  }
  // No shell available (e.g. client without an active tenant).
  return ['/account'];
}

export function accountUrlFromContext(
  currentUrl: string,
  user: User | null | undefined,
): string {
  return accountCommandsFromContext(currentUrl, user).join('/').replace(/\/+/g, '/');
}

export function accountUrlForUser(user: User | null | undefined): string {
  return accountCommandsForUser(user).join('/').replace(/\/+/g, '/');
}
